import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';
import { JsonPrittyPrint } from '../apiref/jsonprittyprint';
import { ApiRef } from '../fasades/apiref';

export function createMessage() : ParameterType
{
    const desc = (<>
        <h3>Message</h3>
        <p>Each input message must be an object with a role and content. You can specify three types of roles:</p>

        <ul>
        <li>system - Sets instructions and context for the entire conversation. This is placed at the beginning of the messages array.</li>
        <li>user - Represents input from the end user</li>
        <li>assistant - Represents responses from the model</li>
        </ul>

        </>);

    return {
        id          : "Message",
        name        : "Message",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "role",
                "type"        : "string",
                "description" : <p>The role of the message sender. Can be "system", "user", or "assistant".</p>,
                "optional"    : false
            },
            {
                "name"        : "content",
                "type"        : "string",
                "description" : <p>The text content of the message.</p>,
                "optional"    : false
            }
        ]
    };
}

export function createMessages() : ParameterType
{
    const childType = ApiRef.getType("Message");

    const json = {
        "model": "your-model-name",
        "messages": [
          {
            "role": "system",
            "content": "You are a helpful API documentation assistant. Provide clear, concise explanations with code examples."
          },
          {
            "role": "user",
            "content": "Why is the sky blue?"
          }
        ]
      };

    const desc = (<>
        <h3>Message Structure</h3>
        <p>Models are trained to operate on alternating user and assistant conversational turns. When creating a new Message, you specify the prior conversational turns with the messages parameter, and the model then generates the next Message in the conversation.</p>
        { childType.description }
        <h3>System Message</h3>

        <p>The system role allows you to provide context, instructions, and guidelines that influence the model's behavior throughout the conversation. System messages are optional but powerful for:</p>

        <ul>
        <li>Defining the assistant's role, personality, or expertise</li>
        <li>Setting response format requirements (e.g., "always respond in JSON")</li>
        <li>Providing domain-specific context or constraints</li>
        <li>Establishing behavioral guidelines</li>
        </ul>

        <p>System messages are included in the messages array as the first message:</p>
        <JsonPrittyPrint value={json} expandTo={10}></JsonPrittyPrint>
        </>);

    return {
        id          : "Message[]",
        name        : "Messages",
        description : desc,
        type        : Type.Array,
        childType   : childType
    };
}

